<template>
    <div class="policy-version-stack">
        <ChildPrivacyPolicy20260507Content />
        <PersonalInfoPolicy20260507Content />
    </div>
</template>

<script>
import ChildPrivacyPolicy20260507Content from '@/views/policy/common/ChildPrivacyPolicy20260507Content.vue';
import PersonalInfoPolicy20260507Content from '@/views/policy/common/PersonalInfoPolicy20260507Content.vue';

export default {
    name: 'ChildPolicy20260507',
    components: {
        ChildPrivacyPolicy20260507Content,
        PersonalInfoPolicy20260507Content,
    },
};
</script>
